import { render } from "./고객의소리.vue?vue&type=template&id=6f51a725"
const script = {}

import "./고객의소리.vue?vue&type=style&index=0&id=6f51a725&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__